import { useEffect } from 'react'

const hasShownEnableNotificationsPromptKey = 'hasShownEnableNotificationsPrompt'

export const useEnableNotificationsPrompt = ({ when = true }: { when?: boolean } = {}) => {
    useEffect(() => {
        if (!when) {
            return
        }

        const hasShownPrompt = localStorage.getItem(hasShownEnableNotificationsPromptKey) === 'true'
        if (hasShownPrompt || typeof Notification === 'undefined') {
            return
        }

        const shouldEnableNotifications = window.confirm(
            "Allow desktop notifications so you don't miss a message"
        )
        localStorage.setItem(hasShownEnableNotificationsPromptKey, 'true')

        if (!shouldEnableNotifications) {
            return
        }

        Notification.requestPermission()
    }, [when])
}
